import React from 'react'

import {
  CurrentUser,
  useCurrentUserContext,
} from '~/views/contexts/CurrentUserContext'

import { isNumber, isString, round } from 'lodash'
import { useStaticLabels } from 'shared/hooks/use-static-labels'

type LoggedEstimatedHoursContentProps = {
  estimatedHours?: number | null
  loggedHours?: number | null
  totalTasksWithUnestimatedHoursCount?: number | null
}

export default function LoggedEstimatedHoursContent({
  loggedHours,
  totalTasksWithUnestimatedHoursCount,
  estimatedHours,
}: LoggedEstimatedHoursContentProps) {
  const [commonLabel] = useStaticLabels(['common'])
  return (
    <div
      className={'flex w-full justify-between'}
      data-component-name={'logged-estimated-hours-container'}
    >
      <span data-component-name={'logged-estimated-hours-label'}>
        {commonLabel('logged')} / {commonLabel('estimated')}
      </span>

      <LoggedEstimatedHoursValueContent
        loggedHours={loggedHours}
        totalTasksWithUnestimatedHoursCount={
          totalTasksWithUnestimatedHoursCount
        }
        estimatedHours={estimatedHours}
      />
    </div>
  )
}

type LoggedEstimatedHoursValueContentProps = {
  estimatedHours?: number | null
  loggedHours?: number | null
  totalTasksWithUnestimatedHoursCount?: number | null
}

function LoggedEstimatedHoursValueContent({
  loggedHours,
  totalTasksWithUnestimatedHoursCount,
  estimatedHours,
}: LoggedEstimatedHoursValueContentProps) {
  const { currentUser } = useCurrentUserContext()

  return (
    <span
      className={'font-bold'}
      data-component-name={'logged-estimated-hours-value'}
    >
      <span className={'font-bold text-black'}>
        {prettifyNumber(loggedHours, currentUser)}
      </span>{' '}
      /{' '}
      <EstimatedHours
        estimatedHours={estimatedHours}
        totalTasksWithUnestimatedHoursCount={
          totalTasksWithUnestimatedHoursCount
        }
      />
    </span>
  )
}

type EstimatedHoursProps = {
  estimatedHours?: number | null
  totalTasksWithUnestimatedHoursCount?: number | null
}

function EstimatedHours({ estimatedHours }: EstimatedHoursProps) {
  const { currentUser } = useCurrentUserContext()

  return (
    <span className={'font-bold'}>
      {prettifyNumber(estimatedHours || 0, currentUser)}
    </span>
  )
}

function prettifyNumber(
  value?: number | null,
  currentUser?: CurrentUser | null,
) {
  try {
    const countryCode = isString(currentUser?.organization?.countryCode)
      ? currentUser?.organization?.countryCode
      : undefined
    return isNumber(value) ? round(value, 2).toLocaleString(countryCode) : 0
  } catch (error) {
    return 0
  }
}
